import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class BillToBillService {
    /**
     * Get authentication token from localStorage
     */
    getAuthToken() {
        const token = localStorage.getItem('adminToken');
        return token ? `Bearer ${token}` : '';
    }

    /**
     * Get all users with their bill-to-bill status
     */
    async getAllUsers(params = {}) {
        try {
            const queryParams = new URLSearchParams();

            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            if (params.search) queryParams.append('search', params.search);

            const response = await axios.get(`${API_URL}/bill-to-bill/users?${queryParams.toString()}`, {
                headers: {
                    'Authorization': this.getAuthToken()
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Toggle user's bill-to-bill status
     */
    async toggleBillToBillStatus(userId, data) {
        try {
            const response = await axios.put(`${API_URL}/bill-to-bill/users/${userId}`, data, {
                headers: {
                    'Authorization': this.getAuthToken(),
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Update user's outstanding amount
     */
    async updateOutstandingAmount(userId, outstandingAmount) {
        try {
            const response = await axios.put(`${API_URL}/bill-to-bill/outstanding/${userId}`, {
                outstanding_amount: outstandingAmount
            }, {
                headers: {
                    'Authorization': this.getAuthToken(),
                    'Content-Type': 'application/json'
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Get bill-to-bill statistics
     */
    async getStats() {
        try {
            const response = await axios.get(`${API_URL}/bill-to-bill/stats`, {
                headers: {
                    'Authorization': this.getAuthToken()
                }
            });

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    /**
     * Handle API errors
     */
    handleError(error) {
        if (error.response) {
            return {
                message: error.response.data.message || 'An error occurred',
                errors: error.response.data.errors || [],
                status: error.response.status
            };
        }
        return {
            message: 'Network error. Please check your connection.',
            errors: [],
            status: 0
        };
    }
}

export default new BillToBillService();